import { EVENT_ACTIONS } from "./../../lib/gtag.js";
const SEARCH_CATEGORIES = {
  Teams: "Teams",
  Competitions: "Competitions",
  Players: "Players"
};
const CATEGORY_TO_PATH = {
  [SEARCH_CATEGORIES.Teams]: "team",
  [SEARCH_CATEGORIES.Competitions]: "league",
  [SEARCH_CATEGORIES.Players]: "player"
};
const CATEGORY_EVENTS = {
  [SEARCH_CATEGORIES.Teams]: EVENT_ACTIONS.TEAM_DETAILS_FROM_SEARCH,
  [SEARCH_CATEGORIES.Competitions]: EVENT_ACTIONS.LEAGUE_DETAILS_FROM_SEARCH
};
export {
  CATEGORY_EVENTS,
  CATEGORY_TO_PATH,
  SEARCH_CATEGORIES
};
